import { createFileRoute } from '@tanstack/react-router'
import { ErrorState } from '@/components/empty-state'
import { PageHeader } from '@/components/page-header'
import { StatusBadge } from '@/components/status-badge'
import { Skeleton } from '@/components/ui/skeleton'
import { useProduct, useSaveProduct } from '@/features/admin/products/api'
import { productToForm } from '@/features/admin/products/product-defaults'
import { ProductForm } from '@/features/admin/products/product-form'
import { notifySuccess } from '@/lib/notify'
import { requirePermission } from '@/lib/route-guards'

export const Route = createFileRoute('/_app/admin/products/$productId')({
  beforeLoad: requirePermission('catalog:manage'),
  component: EditProductPage,
})

function EditProductPage() {
  const { productId } = Route.useParams()
  const { data, isLoading, error, refetch } = useProduct(productId)
  const save = useSaveProduct(productId)
  if (isLoading) return <Skeleton className="h-96 rounded-xl" />
  if (error || !data) {
    return (
      <div className="rounded-xl border border-border bg-card">
        <ErrorState error={error} onRetry={() => void refetch()} />
      </div>
    )
  }
  return (
    <div className="space-y-6">
      <PageHeader
        eyebrow={`Productos de crédito · ${data.code}`}
        title={data.name}
        description="Los cambios aplican solo a solicitudes nuevas."
        meta={<StatusBadge kind="active" value={String(data.isActive)} />}
      />
      <ProductForm
        key={data.updatedAt}
        initialValues={productToForm(data)}
        submitLabel="Guardar cambios"
        onSubmit={async (values) => {
          await save.mutateAsync(values)
          notifySuccess('Producto actualizado')
        }}
      />
    </div>
  )
}
